
///日期时间帮助类
const dateTimeHelper = {
    ///计算时间 ago 显示文本
    calcAgoShowTime: function (time) {
        const now = new Date();
        const past = new Date(time);
        const diffMs = now - past; // 毫秒差值

        if (diffMs < 0) return '未来时间'; // 处理未来时间的情况

        const seconds = Math.floor(diffMs / 1000);
        if (seconds < 60) return `${seconds}秒前`;

        const minutes = Math.floor(seconds / 60);
        if (minutes < 60) return `${minutes}分钟前`;

        const hours = Math.floor(minutes / 60);
        if (hours < 24) return `${hours}小时前`;

        const days = Math.floor(hours / 24);
        if (days < 30) return `${days}天前`;

        const months = Math.floor(days / 30);
        if (months < 12) return `${months}个月前`;

        const years = Math.floor(months / 12);
        return `${years}年前`;
    }
}

export default dateTimeHelper